export default __webpack_public_path__ + "static/media/example_img_1_1.5b1a41b1.png";